import {Button, ButtonGroup} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';

export function LanguageSwitcher() {
	const {i18n} = useTranslation();

	const changeLanguage = (lng: string) => {
		i18n.changeLanguage(lng)
			.then(() => {
				console.log('Language changed to: ' + lng);
			});
	};

	return (
		<ButtonGroup size="small" sx={{
			position: 'absolute',
			display: "none"
		}}>
			<Button
				onClick={() => changeLanguage('sl')}
				color={"secondary"}
				variant={i18n.language === 'sl' ? 'contained' : 'outlined'}
			>
				SLO
			</Button>
			<Button
				onClick={() => changeLanguage('en')}
				color={"secondary"}
				variant={i18n.language === 'en' ? 'contained' : 'outlined'}
			>
				ENG
			</Button>
		</ButtonGroup>
	);
} 